import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProviderService } from 'src/app/services/provider.service';
import { Operator } from '../../models/operator';

@Component({
  selector: 'app-operator-dropdown',
  templateUrl: './operator-dropdown.component.html',
  styleUrls: ['./operator-dropdown.component.css'],
})
export class OperatorDropdownComponent implements OnInit {
  operators: Operator[] = [];
  selectedOperator: Operator | null= null;

  selectedValue : null | string= null;
  isLoading = false;

  @Output() operatorEvent: EventEmitter<Operator> =
    new EventEmitter<Operator>();
  constructor(private provider: ProviderService) {}
  

  ngOnInit() {
    this.loadOperators();
  }

  // click(operator: Operator) {
  //   this.selectedOperator = operator;
  //   this.operatorEvent.emit(operator)
  // }

  click(operator: any) {
 
    const selectedOperator = this.operators.find((c) => c.id == operator);
    if (!selectedOperator) {
      return;
    } 
    this.selectedOperator = selectedOperator;
    this.operatorEvent.emit(this.selectedOperator);
    this.provider.setOnChangeOperatorSource(this.selectedOperator);
  }

  loadOperators() {
    this.isLoading = true;
    this.provider.loadOperators().subscribe({
      next: (operators) => {
        this.operators = operators;
        
        if (operators.length > 0) {
          this.setDefaultOperator(operators[0]);          
        }
        
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.operators = [];
      },
    });
  }

  setDefaultOperator(operator : Operator){
    this.selectedValue = operator.id
    this.click(operator.id)
  }
}
